import { put, call, take, select } from "redux-saga/effects"
import { eventChannel } from 'redux-saga'
import { pathOr } from 'ramda'

import { snackbarActions } from 'reduxModules/actions/SnackbarActions'
import { lineIdSelector } from 'reduxModules/selectors/UserSelectors'
import { snackbarStateSelector } from 'reduxModules/selectors/SnackbarSelectors'

import { rsf } from '../../firebase'

import { handlePhoneNumber } from 'services/helpers'
import Phonet from 'services/phonet'

const subscribeToCall = id =>
  eventChannel(emitter => {
    const socket = Phonet.wss.subscribeToCall(id)

    socket.onmessage = e =>
      emitter(JSON.parse(e.data))

    return () => {
      socket.close()
    }
  })

export function* subscribeToCallSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    const phonetLineId = yield select(lineIdSelector)

    if (!phonetLineId) {
      yield put(responseFailure())
      return
    }

    const channel = yield call(subscribeToCall, phonetLineId)

    while (true) {
      const data = yield take(channel)
      const isSnackbarOpen = yield select(snackbarStateSelector)
      
      const incomingCall = data.lgDirection === 4
      const pickup = data.event === 'call.bridge'

      if (incomingCall && pickup && !isSnackbarOpen) {
        const phoneNumber = handlePhoneNumber(data.otherLegs[0].num)

        const res = yield call(rsf.firestore.getDocument, `passengers/${phoneNumber}`)

        const phonetPassenger = pathOr(data.otherLegs[0], ['otherLegs', 1], data)
        const [firstName, lastName] = pathOr('', ['name'], phonetPassenger).split(' ')

        const phonetFullName = firstName && lastName
          ? ` | ${firstName} ${lastName}`
          : ''

        if (res.exists) {
          const resData = res.data()

          yield put(responseSuccess({ phone: res.id, ...resData }))

          const passenger = resData.firstName && resData.lastName
            ? ` | ${resData.firstName} ${resData.lastName}`
            : phonetFullName || ''

          yield put(snackbarActions.showSnackbar({
            type: 'phonet',
            message: `${res.id}${passenger}`
          }))
        } else {
          yield put(snackbarActions.showSnackbar({
            type: 'phonet',
            message: `${phonetPassenger.num}${phonetFullName}`
          }))

          yield put(responseSuccess(data.otherLegs[1]))
        }
      }
    }
  } catch (err) {
    console.log(err)
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження інформації про вхідні дзвінки!'
    }))
    yield put(responseFailure())
  }
}



// WEBPACK FOOTER //
// ./src/reduxModules/sagas/PhonetSagas.js